// extracted by mini-css-extract-plugin
export var video = "LessonViewer-module--video--U6Fk6";